// extracted by mini-css-extract-plugin
module.exports = {"root":"answer_root__ghIq5","count":"answer_count__g852d","content":"answer_content__45ECx","isSelected":"answer_isSelected__2fOjY"};